import request from '@/utils/request'

// 分页查询学习进度
export function reqLearnProgressPage(data) {
    return request({
        url: '/education/learn/progress/page',
        method: 'post',
        data
    })
}

// 查询学习进度详情
export function reqLearnProgressDetail(id) {
    return request({
        url: '/education/learn/progress/detail',
        method: 'get',
        params: { id }
    })
}

// 新增学习进度
export function reqLearnProgressInsert(data) {
    return request({
        url: '/education/learn/progress/insert',
        method: 'post',
        data
    })
}

// 更新学习进度
export function reqLearnProgressUpdate(data) {
    return request({
        url: '/education/learn/progress/update',
        method: 'post',
        data
    })
}

// 删除学习进度
export function reqLearnProgressDelete(id) {
    return request({
        url: '/education/learn/progress/delete',
        method: 'get',
        params: { id }
    })
}
